<div mat-dialog-container>
    <div class="mat-dialog-header-content">
      <mat-icon class="{{'icon ' + data.messageType + '-icon'}}">{{icons[data.messageType].icon}}</mat-icon>
    </div>
    <div class="mat-dialog-header-content">
      <h1>{{data.messageTitle}}</h1>
    </div>
    <form [formGroup]="gradeCourseForm">
        <mat-form-field appearance="outline" class="mat-dialog-content">
            <mat-label>{{'COURSES.COURSE'|translate}}</mat-label>
            <mat-select [formControl]="gradeCourseForm.get('courses')" multiple disableOptionCentering #select>
            <mat-select-trigger>
              <mat-chip-list #courseList aria-label="Selección de curso">
              <mat-chip
                *ngFor="let course of gradeCourseForm.get('courses').value"
                [removable]="true"
                (removed)="removeCourse(course)">
                {{course.name}}
                <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
              </mat-chip>
              <!-- <input
                placeholder="nuevo curso..."
                #courseInput
                formControlName="courses"
                [matAutocomplete]="courseSelect"
                [matChipInputFor]="courseList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addCourse($event)">-->
            </mat-chip-list> 
            </mat-select-trigger>
            <!-- <mat-autocomplete #courseSelect="matAutocomplete" (optionSelected)="courseSelected($event)"> -->
              <mat-option *ngFor="let course of filteredCourses | async" [value]="course">
                {{course.name}}
              </mat-option>
            <!-- </mat-autocomplete> -->
            <mat-hint *ngIf="false">{{'DIALOGMESSAGECOURSE.ADDTOCOURSETITLE'|translate}}</mat-hint>
            </mat-select>
          </mat-form-field>
    </form>
    <div mat-dialog-actions align="end">
      <button mat-flat-button color="primary" [mat-dialog-close]="sendto()" cdkFocusInitial>{{'MENU_CARD.ACCEPT'|translate}}</button>
      <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="accent"
        [mat-dialog-close]="false" (click)="closeMe()">{{'MENU_CARD.CANCEL'|translate}}</button>
      <button mat-flat-button *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'" color="primary"
        [mat-dialog-close]="true" (click)="closeMe()">{{'MENU_CARD.CANCEL'|translate}}</button>
    </div>
  </div>
  